import get from "lodash/get";

import {
  CLEAR_SMART_UI_DETAILS,
  GET_SMART_UI_DETAILS_LOADING,
  GET_SMART_UI_DETAILS_SUCCESS,
  GET_SMART_UI_DETAILS_FAILED
} from "../actionTypeConstants/smartUi";

const initialState = {
  dashboardLink: "",
  buildName: "",
  projectName: "",
  baseline: false,
  screenshotStatus: {},
  error: null,
  loading: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_SMART_UI_DETAILS_LOADING:
      return {
        ...state,
        loading: true
      };

    case GET_SMART_UI_DETAILS_SUCCESS:
      const smartUiDetails = get(action, ["result", "data"], {});
      const buildInfo = get(smartUiDetails, ["build"], {});
      const projectName = get(smartUiDetails, ["projectName"], "");
      const {
        baseline = false,
        name: buildName = "",
        screenshotStatus = {}
      } = buildInfo
      const smartUiLink = get(
        smartUiDetails,
        ["data", 0, "smartuiDashboardLink"],
        ""
      );
      return {
        ...state,
        loading: false,
        baseline,
        buildName,
        projectName,
        screenshotStatus,
        dashboardLink: smartUiLink
      };

    case GET_SMART_UI_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        dashboardLink: "",
        baseline: false,
        buildName: "",
        projectName: "",
        screenshotStatus: {},
      };

    case CLEAR_SMART_UI_DETAILS: {
      return {
        ...state,
        ...initialState
      };
    }

    default:
      return state;
  }
}
